<template>
  <div class="main">
    <!-- title -->
    <h3 class="title" content="edit" placement="bottom">
      Business Partner Management
      <el-button style="width: 180px" @click="handleExport"> Export </el-button>
      <span class="search-toggle" @click="searchExpanded = !searchExpanded">
        {{ searchExpanded ? "Hide Filters" : "Show Filters" }}
        <em class="el-icon-arrow-up" :class="{ 'is-collapsed': !searchExpanded }"></em>
      </span>
      <!--
      <el-button style="width:180px;margin-right:10px;" v-if="$store.state.userLevel == 1" @click="handleSchedule">
        Run Schedule
      </el-button>
       -->
    </h3>
    <!-- search -->
    <div class="searchBox" v-show="searchExpanded">
      <el-form :model="formInline" ref="formInline" class="demo-form-inline">
        <div class="search-grid">
          <el-form-item prop="clientID">
            <el-input
              v-model="formInline.clientID"
              placeholder="VendorID/EmployeeID"
              @keyup.enter.native="submitSearch"
              maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item prop="lastName">
            <el-input
              v-model="formInline.lastName"
              placeholder="Last Name"
              @keyup.enter.native="submitSearch"
              maxlength="50"
            ></el-input>
          </el-form-item>
          <el-form-item prop="firstName">
            <el-input
              v-model="formInline.firstName"
              placeholder="First Name"
              @keyup.enter.native="submitSearch"
              maxlength="50"
            ></el-input>
          </el-form-item>
          <el-form-item prop="email">
            <el-input
              v-model="formInline.email"
              placeholder="Email"
              @keyup.enter.native="submitSearch"
              maxlength="50"
            ></el-input>
          </el-form-item>
          <el-form-item prop="representative">
            <el-input
              v-model="formInline.representative"
              placeholder="Account Manager"
              @keyup.enter.native="submitSearch"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div class="search-toolbar">
        <div class="search-toolbar__actions">
          <el-button type="primary" class="search" @click="submitSearch"
            >Search</el-button
          >
          <el-button class="reset" @click="resetForm('formInline')"
            >Reset</el-button
          >
        </div>
      </div>
    </div>
    <!-- toolbar, table & pagination share one panel -->
    <div class="client-panel">
      <div class="client-panel__toolbar">
        <div class="search-toolbar__extra">
          <columns-control
            :columns="columnsConfig"
            storage-key="cms.bizUserManagement.columns"
            @change="onColumnsChange"
          ></columns-control>
          <!-- filter & sort by -->
          <el-dropdown trigger="click" ref="filter">
          <span class="el-dropdown-link sortbox">
            <em class="filter"></em>
            Filter
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-form
              ref="formFilter"
              :model="formFilter"
              style="width: 300px; padding: 14px 24px"
            >
              <el-form-item
                label="Sales Office"
                style="margin-bottom: 12px"
                prop="salesOffice"
              >
                <el-select
                  v-model="formFilter.salesOffice"
                  :popper-append-to-body="false"
                  @change="changeSalesOffice"
                  :disabled="$store.state.userLevel >= 2"
                >
                  <el-option value="All">All</el-option>
                  <el-option
                    v-for="(item, index) in salesOfficeList"
                    :key="index"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="Region"
                style="margin-bottom: 12px"
                prop="region"
              >
                <el-select
                  v-model="formFilter.region"
                  :popper-append-to-body="false"
                >
                  <el-option value="All">All</el-option>
                  <el-option
                    v-for="(item, index) in regionList"
                    :key="index"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="User status"
                style="margin-bottom: 12px"
                prop="status"
              >
                <el-select
                  v-model="formFilter.status"
                  :popper-append-to-body="false"
                >
                  <el-option value="All">All</el-option>
                  <el-option
                    v-for="(item, index) in userStatusList"
                    :key="index"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item
                label="Account Manager"
                style="margin-bottom: 12px"
                prop="type"
              >
                <el-select
                  v-model="formFilter.account"
                  :popper-append-to-body="false"
                >
                  <el-option value="All">All</el-option>
                  <el-option
                    v-for="(item, index) in acctountList"
                    :key="index"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item
                label="Record type"
                style="margin-bottom: 12px"
                prop="type"
              >
                <el-select
                  v-model="formFilter.sfRecordType"
                  :popper-append-to-body="false"
                >
                  <el-option value="All">All</el-option>
                  <el-option
                    v-for="(item, index) in this.sfRecordTypeList"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
              <div class="filterButton">
                <el-form-item style="margin-right: 15px; margin-bottom: 0">
                  <el-button
                    class="reset"
                    @click="
                      $refs.filter.hide();
                      resetForm('formFilter');
                    "
                    >Reset</el-button
                  >
                </el-form-item>
                <el-form-item style="margin-bottom: 0">
                  <el-button
                    type="primary"
                    class="search"
                    @click="
                      () => {
                        $refs.filter.hide();
                        submitSearch();
                      }
                    "
                    >Apply</el-button
                  >
                </el-form-item>
              </div>
            </el-form>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown trigger="click" @command="handleCommand">
          <span class="el-dropdown-link sortbox">
            <em class="sort"></em>
            Sort by
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="['lastLoginAt,desc', 'id,asc']"
              >Last Login Date (New - Old)</el-dropdown-item
            >
            <el-dropdown-item :command="['lastLoginAt,asc', 'id,asc']"
              >Last Login Date (Old - New)</el-dropdown-item
            >
            <el-dropdown-item :command="['cmsUpdatedAt,desc', 'id,asc']"
              >Last Update date (New - Old)</el-dropdown-item
            >
            <el-dropdown-item :command="['cmsUpdatedAt,asc', 'id,asc']"
              >Last Update date (Old - New)</el-dropdown-item
            >
            <el-dropdown-item :command="['activationAt,desc', 'id,asc']"
              >Activation Date (New - Old)</el-dropdown-item
            >
            <el-dropdown-item :command="['activationAt,asc', 'id,asc']"
              >Activation Date (Old - New)</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
      <div class="client-panel__tags" v-if="tagList.length">
      <el-tag
        v-for="tag in tagList"
        :key="tag.code"
        closable
        type="info"
        style="margin: 0 5px"
        :disable-transitions="false"
        @close="handleClose(tag)"
      >
        {{ tag.tag }}
      </el-tag>
    </div>
    <el-table :data="tableData">
      <el-table-column v-if="isColumnVisible('category')" label="Category" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{
          $commonjs.sfUserTypeMap(scope.row.sfUserType)
        }}</template>
      </el-table-column>
      <el-table-column v-if="isColumnVisible('recordType')" label="Record Type">
        <template slot-scope="scope">{{
          scope.row.salesforceRecordType.hasOwnProperty("name")
            ? scope.row.salesforceRecordType.name
            : "-"
        }}</template>
      </el-table-column>
      <el-table-column
        v-if="isColumnVisible('clientID')"
        prop="clientID"
        label="VendorID/EmployeeID"
        width="180"
      ></el-table-column>
      <el-table-column
        v-if="isColumnVisible('representative')"
        prop="representative"
        label="Account Manager"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column v-if="isColumnVisible('salesOffice')" label="Sales Office" width="80">
        <template slot-scope="scope">{{
          $commonjs.salesOfficeMap(scope.row.salesOffice)
        }}</template>
      </el-table-column>
      <el-table-column v-if="isColumnVisible('region')" label="Region" width="80">
        <template slot-scope="scope">{{
          $commonjs.regionMap(scope.row.region)
        }}</template>
      </el-table-column>
      <el-table-column
        v-if="isColumnVisible('name')"
        prop="name"
        label="Name"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column v-if="isColumnVisible('username')" prop="username" label="Username"></el-table-column>
      <el-table-column v-if="isColumnVisible('salesforceEmail')" prop="salesforceEmail" label="Email"></el-table-column>
      <el-table-column
        v-if="isColumnVisible('cellularphone')"
        prop="cellularphone"
        label="Mobile Phone"
      ></el-table-column>
      <el-table-column
        v-if="isColumnVisible('lastLoginAt')"
        prop="lastLoginAt"
        label="Last login"
        :formatter="$commonjs.tableFormatDateTime"
        width="140"
      ></el-table-column>
      <el-table-column
        v-if="isColumnVisible('activationAt')"
        prop="activationAt"
        label="Activation Date"
        :formatter="$commonjs.tableFormatDateTime"
        width="140"
      ></el-table-column>
      <el-table-column v-if="isColumnVisible('status')" label="Status" width="80">
        <template slot-scope="scope">
          <span :class="'userstatus-' + scope.row.userStatus">
            {{ $commonjs.userStatusMap(scope.row.userStatus) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="isColumnVisible('cmsUpdatedAt')"
        prop="cmsUpdatedAt"
        label="Last update"
        :formatter="$commonjs.tableFormatDateTime"
        width="140"
      >
      </el-table-column>
      <el-table-column label="Operation" width="100">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="Edit" placement="top">
            <em
              class="edit"
              style="margin-right: 10px"
              @click="handleEdit(scope.row)"
            ></em>
          </el-tooltip>
          <el-tooltip
            v-if="showSave"
            class="item"
            effect="dark"
            content="More"
            placement="top"
          >
            <el-dropdown
              v-if="scope.row.userStatus != 'OPENED'"
              trigger="click"
              @command="(command) => handleMore(command, scope.row)"
            >
              <span class="el-dropdown-link sortbox">
                <em class="more"></em>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-if="scope.row.userStatus != 'OPENED'"
                  command="emailUserName"
                  >Email Username</el-dropdown-item
                >
                <el-dropdown-item
                  v-if="scope.row.userStatus != 'OPENED'"
                  command="restPassword"
                  >Reset password</el-dropdown-item
                >

                <!-- <el-dropdown-item
                  v-if="scope.row.userStatus != 'OPENED'"
                  :command="
                    scope.row.userStatus == 'SUSPENDED'
                      ? 'activeAccount'
                      : 'suspendAccount'
                  "
                >
                  {{
                    scope.row.userStatus == "SUSPENDED"
                      ? "Unsuspend account"
                      : "Suspend account"
                  }}
                </el-dropdown-item> -->
                <!--
                <el-dropdown-item command="deleteAccount" v-if="$store.state.userLevel <= 2">Delete account</el-dropdown-item>
                -->
              </el-dropdown-menu>
            </el-dropdown>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <!-- page -->
    <app-pagination
      @size-change="
        (v) => {
          currentSize = v;
          currentPage = 1;
          getList();
        }
      "
      @current-change="
        (v) => {
          currentPage = v;
          getList();
        }
      "
      :current-page="currentPage"
      :page-sizes="[5, 10, 20, 50]"
      :total="total"
      :page-size="currentSize"
    ></app-pagination>
    </div>
    <el-dialog
      :visible.sync="demandDialog"
      width="420px"
      :close-on-click-modal="false"
      @close="$refs.formDemand.resetFields()"
    >
      <h3 slot="title" class="demandDialogTitle">
        Starting from the following dates, get all updated/created customers
        from Salesforce:
      </h3>
      <el-form
        ref="formDemand"
        :model="formDemand"
        :rules="formDemandRules"
        class="formDemand"
      >
        <el-form-item prop="dateTime">
          <el-row
            :gutter="10"
            justify="space-between"
            type="flex"
            style="margin-bottom: 0"
          >
            <el-col :span="12">
              <el-form-item prop="date" label="Start Date">
                <el-date-picker
                  @change="handledateTime"
                  v-model="formDemand.date"
                  type="date"
                  range-separator="/"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                  placeholder="Date"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="time" label="Start Time">
                <el-time-select
                  @change="handledateTime"
                  v-model="formDemand.time"
                  :picker-options="{
                    start: '00:00',
                    step: '00:15',
                    end: '24:00',
                  }"
                  style="width: 100%"
                  placeholder="Time"
                >
                </el-time-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: -30px">
        <el-button @click="demandDialog = false">Cancel</el-button>
        <el-button type="primary" @click="handleRunDemand">Confirm</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  bizUserList,
  getSalesOffice,
  getSalesRegion,
  getUserStatus,
  getUserType,
  getSfUserTypes,
  appUserSuspend,
  appUserUnlock,
  appUserDelete,
  appUserEmail,
  appUserResetPwd,
  bizUserExport,
  employeesFindAll,
  Export,
  runFetchBizUserSchedule,
} from "@/request/api";
export default {
  name: "bizUser",
  data() {
    var startDateValidator = (rule, value, callback) => {
      if (new Date(value).getTime() > new Date().getTime()) {
        callback(new Error("Start Date cannot be later than the present time"));
      } else {
        callback();
      }
    };
    return {
      showSave: true,
      formInline: {
        clientID: "",
        lastName: "",
        firstName: "",
        username: "",
      },
      exportList: {},
      tableData: [],
      currentSize: 10,
      currentPage: 1,
      sort: ["lastLoginAt,desc", "id,asc"],
      total: 0,
      dialogUserVisible: false,
      formLabelWidth: "96px",
      formUser: {
        id: 0,
        username: "",
        password: "",
        roles: [],
      },
      rulesUser: {
        username: [
          { required: true, message: "The User Name cannot be empty" },
          { max: 100, message: "The length cannot exceed 100" },
        ],
        password: [
          { required: true, message: "The Password cannot be empty" },
          { max: 100, message: "The length cannot exceed 100" },
        ],
        roles: [{ required: true, message: "The Roles cannot be empty" }],
      },
      rolesList: [],
      oldPassword: "",
      formFilter: {
        sfRecordType:"All",
        salesOffice: "All",
        region: "All",
        status: "All",
        type: "All",
        account: "All",
        
      },
      salesOfficeList: [],
      regionList: [],
      userTypeList: [],
      sfUserTypeList: [],
      acctountList: [],
      userStatusList: [],
      demandDialog: false,
      formDemand: {
        dateTime: "",
        date: "",
        time: "",
      },
      formDemandRules: {
        dateTime: [
          { required: true, message: "Start Date & Time cannot be empty" },
          { validator: startDateValidator },
        ],
      },
      sfRecordTypeList: [
        { name: "Corporate Partner" },
        { name: "Planner / Broker" },
        { name: "Individual Partner" },
        { name: "Account Manager" },
      ],
      tagList: [],
      searchExpanded: true,
      columnsConfig: [
        { prop: "category", label: "Category", visible: true },
        { prop: "recordType", label: "Record Type", visible: true },
        { prop: "clientID", label: "VendorID/EmployeeID", visible: true },
        { prop: "representative", label: "Account Manager", visible: true },
        { prop: "salesOffice", label: "Sales Office", visible: true },
        { prop: "region", label: "Region", visible: true },
        { prop: "name", label: "Name", visible: true },
        { prop: "username", label: "Username", visible: true },
        { prop: "salesforceEmail", label: "Email", visible: true },
        { prop: "cellularphone", label: "Mobile Phone", visible: true },
        { prop: "lastLoginAt", label: "Last login", visible: true },
        { prop: "activationAt", label: "Activation Date", visible: true },
        { prop: "status", label: "Status", visible: true },
        { prop: "cmsUpdatedAt", label: "Last update", visible: true },
      ],
      visibleColumnProps: [
        "category",
        "recordType",
        "clientID",
        "representative",
        "salesOffice",
        "region",
        "name",
        "username",
        "salesforceEmail",
        "cellularphone",
        "lastLoginAt",
        "activationAt",
        "status",
        "cmsUpdatedAt",
      ],
    };
  },
  methods: {
    isColumnVisible(prop) {
      return this.visibleColumnProps.includes(prop);
    },
    onColumnsChange(visibleProps) {
      this.visibleColumnProps = visibleProps;
    },
    showBtn(val) {
      console.log(this.$store.state.permissions);
      var permissions = this.$store.state.permissions.filter(
        (item) => item == val
      );
      if (!permissions[0]) {
        this.showSave = false;
      }
    },
    getUserStatusConfig() {
      getUserStatus().then((res) => {
        this.userStatusList = res.data.payload;
      });
    },
    getUserTypeConfig() {
      getUserType().then((res) => {
        this.userTypeList = res.data.payload;
      });
    },
    getSfUserTypeConfig() {
      getSfUserTypes().then((res) => {
        this.sfUserTypeList = res.data.payload.filter((x) => x.code !== "CL");
      });
    },
    getFilterConfig() {
      getSalesOffice().then((res) => {
        this.salesOfficeList = res.data.payload;
      });
    },
    changeSalesOffice(v) {
      if (v == "All") {
        this.clearRegion();
      } else {
        this.clearRegion();
        getSalesRegion(v).then((res) => {
          this.regionList = res.data.payload;
        });
      }
    },
    clearRegion() {
      this.regionList = [];
      this.$set(this.formFilter, "region", "");
    },
    handleCommand(command) {
      this.sort = command;
      this.submitSearch();
    },

    getProducts() {
      employeesFindAll().then((res) => {
        var option = [];
        res.data.payload.map((item) => {
          option.push({ code: item.employeeId, name: item.fullName });
        });
        console.log(option);
        this.acctountList = option;
      });
    },

    getList() {
      this.exportList = null;
      let params = {
        page: this.currentPage - 1,
        size: this.currentSize,
        sort: this.sort,
      };
      var neoexportlist = {};
      if (this.formInline.clientID) {
        params["clientID"] = this.formInline.clientID;
        neoexportlist.clientID = this.formInline.clientID;
      }

      if (this.formInline.firstName) {
        params["firstName"] = this.formInline.firstName;
        neoexportlist.firstName = this.formInline.firstName;
      }

      if (this.formInline.lastName) {
        params["lastName"] = this.formInline.lastName;
        neoexportlist.lastName = this.formInline.lastName;
      }

      if (this.formInline.userName) {
        params["username"] = this.formInline.userName;
        neoexportlist.userName = this.formInline.userName;
      }

      if (this.formInline.name) {
        params["name"] = this.formInline.name;
        neoexportlist.name = this.formInline.name;
      }
      if (this.formInline.email) {
        params["email"] = this.formInline.email;
        neoexportlist.email = this.formInline.email;
      }

      if (this.formInline.representative) {
        params["representative"] = this.formInline.representative;
        neoexportlist.representative = this.formInline.representative;
      }

      var list = [];
      if (this.formFilter.salesOffice && this.formFilter.salesOffice != "All") {
        params["salesOffice"] = this.formFilter.salesOffice;
        neoexportlist.salesOffice = this.formFilter.salesOffice;
        var salesOffice = this.salesOfficeList.filter(
          (item) => item.code === this.formFilter.salesOffice
        );
        list.push({
          tag: "SalesOffice:" + salesOffice[0].name,
          name: salesOffice[0].name,
          code: salesOffice[0].code,
          type: "salesOffice",
        });
      }

      if (this.formFilter.region && this.formFilter.region != "All") {
        params["region"] = this.formFilter.region;
        neoexportlist.region = this.formFilter.region;
        var region = this.regionList.filter(
          (item) => item.code === this.formFilter.region
        );
        list.push({
          tag: "Region:" + region[0].name,
          name: region[0].name,
          code: region[0].code,
          type: "region",
        });
      }

      if (this.formFilter.account && this.formFilter.account != "All") {
        params["clientID"] = this.formFilter.account;
        neoexportlist.account = this.formFilter.account;
        var account = this.acctountList.filter(
          (item) => item.code === this.formFilter.account
        );
        list.push({
          tag: "Account:" + account[0].name,
          name: account[0].name,
          code: account[0].code,
          type: "account",
        });
      }

      if (this.formFilter.status && this.formFilter.status != "All") {
        params["userStatus"] = this.formFilter.status;
        neoexportlist.userStatus = this.formFilter.status;
        var status = this.userStatusList.filter(
          (item) => item.code === this.formFilter.status
        );
        list.push({
          tag: "userStatus:" + status[0].name,
          name: status[0].name,
          code: status[0].code,
          type: "status",
        });
      }

      if (this.formFilter.type && this.formFilter.type != "All") {
        params["userType"] = this.formFilter.type;
        neoexportlist.userType = this.formFilter.type;
      }

      if (this.formFilter.sfUserType && this.formFilter.sfUserType != "All") {
        params["sfUserType"] = this.formFilter.sfUserType;
        neoexportlist.sfUserType = this.formFilter.sfUserType;
        var sfUserType = this.sfUserTypeList.filter(
          (item) => item.code === this.formFilter.sfUserType
        );
        list.push({
          tag: "Category:" + sfUserType[0].name,
          name: sfUserType[0].name,
          code: sfUserType[0].code,
          type: "sfUserType",
        });
      }

      if (
        this.formFilter.sfRecordType &&
        this.formFilter.sfRecordType != "All"
      ) {
        params["sfRecordType"] = this.formFilter.sfRecordType;
        neoexportlist.sfRecordType = this.formFilter.sfRecordType;
        var sfRecordType = this.sfRecordTypeList.filter(
          (item) => item.name === this.formFilter.sfRecordType
        );
        console.log(this.formFilter.sfRecordType);
        console.log(sfRecordType);

        list.push({
          tag: "Record type:" + sfRecordType[0].name,
          name: sfRecordType[0].name,
          code: sfRecordType[0].name,
          type: "sfRecordType",
        });
      }

      this.tagList = list;
      this.exportList = neoexportlist;
      bizUserList(params).then((res) => {
        console.log(res);
        this.tableData = res.data.content;
        this.total = res.data.totalElements;
      });
    },
    // handleAdd() {
    //   this.$router.push({path:'/createUser'})
    // },
    handleEdit(row) {
      this.$router.push({
        path: "/editPartner/" + row.sfUserType + "/" + row.clientID,
      });
    },
    submitSearch() {
      this.currentPage = 1;
      this.getList();
    },
    resetForm(formName) {
      this.exportList = null;
      this.$refs[formName].resetFields();
      if(formName === 'formFilter'){
        this.formFilter.sfRecordType = 'All'
      }
      this.getList();
    },
    handleMore(command, row) {
      if (command == "suspendAccount") {
        const h = this.$createElement;
        this.$msgbox({
          message: h("div", { style: "padding:15px 0" }, [
            h(
              "p",
              {
                style:
                  "color:#003448;text-align:center;font-size:20px;margin-bottom:20px;font-weight:bold;line-height: 1.5;",
              },
              "Are you sure to suspend this user account?"
            ),
            h(
              "p",
              { style: "color:#003448;font-size:13px;margin-bottom:-20px;" },
              "Remarks"
            ),
          ]),
          showCancelButton: true,
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showInput: true,
          inputPlaceholder: "Please enter remarks",
          confirmButtonClass: "msg_button",
          cancelButtonClass: "msg_button",
          closeOnPressEscape: false,
          closeOnClickModal: false,
          callback: (action, instance) => {
            let button = action;
            let input = instance.$refs.input.value;
            if (button == "confirm") {
              let params = { userStatusRemark: input };
              appUserSuspend(row.id, params).then((res) => {
                if (res.data.status == "00") {
                  this.$message.success("Account is suspended");
                  this.getList();
                } else {
                  this.$message.error(res.data.msg);
                }
              });
            }
          },
        });
      }
      if (command == "activeAccount") {
        const h = this.$createElement;
        this.$msgbox({
          message: h("div", { style: "padding:15px 0" }, [
            h(
              "p",
              {
                style:
                  "color:#003448;text-align:center;font-size:20px;font-weight:bold;line-height: 1.5;",
              },
              "Are you sure to unsuspend this user account?"
            ),
          ]),
          showCancelButton: true,
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          confirmButtonClass: "msg_button_half",
          cancelButtonClass: "msg_button_half",
          closeOnPressEscape: false,
          closeOnClickModal: false,
          callback: (action, instance) => {
            let button = action;
            if (button == "confirm") {
              appUserUnlock(row.id).then((res) => {
                if (res.data.status == "00") {
                  this.$message.success("Account is unsuspended");
                  this.getList();
                } else {
                  this.$message.error(res.data.msg);
                }
              });
            }
          },
        });
      }
      if (command == "deleteAccount") {
        const h = this.$createElement;
        this.$msgbox({
          message: h("div", { style: "padding:15px 0" }, [
            h(
              "p",
              {
                style:
                  "color:#003448;text-align:center;font-size:20px;font-weight:bold;line-height: 1.5;",
              },
              "Are you sure to delete this user account?"
            ),
          ]),
          showCancelButton: true,
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          confirmButtonClass: "msg_button_half",
          cancelButtonClass: "msg_button_half",
          closeOnPressEscape: false,
          closeOnClickModal: false,
          callback: (action, instance) => {
            let button = action;
            if (button == "confirm") {
              appUserDelete(row.id).then((res) => {
                if (res.data.status == "00") {
                  this.$message.success("Account is deleted");
                  this.getList();
                } else {
                  this.$message.error(res.data.msg);
                }
              });
            }
          },
        });
      }
      if (command == "emailUserName") {
        const h = this.$createElement;
        this.$prompt(
          h("div", { style: "padding:0 0 15px" }, [
            h(
              "p",
              {
                style:
                  "color:#003448;text-align:center;font-size:20px;margin-bottom:20px;font-weight:bold;line-height: 1.5;",
              },
              "Send a username reminder email to user's email address."
            ),
            h(
              "p",
              { style: "color:#003448;font-size:13px;margin-bottom:-20px;" },
              "Email address"
            ),
          ]),
          "",
          {
            showClose: false,
            showCancelButton: true,
            confirmButtonText: "Send",
            cancelButtonText: "Cancel",
            showInput: true,
            inputPlaceholder: "Please enter email address",
            confirmButtonClass: "msg_button",
            cancelButtonClass: "msg_button",
            closeOnPressEscape: false,
            closeOnClickModal: false,
            inputPattern:
              /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
            inputErrorMessage: "Please provide a properly formatted email",
            inputValue: row.salesforceEmail ? row.salesforceEmail : null,
          }
        )
          .then(({ value }) => {
            let newValue = value;
            let oldValue = row.salesforceEmail;
            let params = { email: newValue, updateEmail: false };
            appUserEmail(row.id, params).then((res) => {
              if (res.data.status == "00") {
                this.$message.success("Email sent");
                this.getList();
              } else {
                this.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {});
      }
      if (command == "restPassword") {
        this.resetPwdNoPopup(row);
      }
    },
    handledateTime() {
      if (this.formDemand.date && this.formDemand.time) {
        this.formDemand.dateTime =
          this.formDemand.date + " " + this.formDemand.time;
        this.$refs.formDemand.validateField(["dateTime"]);
      } else {
        this.formDemand.dateTime = "";
        this.$refs.formDemand.validateField(["dateTime"]);
      }
    },
    handleRunDemand() {
      this.$refs.formDemand.validate((valid) => {
        if (valid) {
          console.log(this.formDemand);
          let params = { startDate: this.formDemand.dateTime };
          runOnDemand(params).then((res) => {
            console.log(res);
            if (res.data.status == "00") {
              this.$message.success("Run success!");
              this.demandDialog = false;
              this.getList();
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      });
    },
    resetPwdYesPopup(row) {
      const el = this.$createElement;
      this.$prompt(
        el("div", { style: "padding:0 0 15px" }, [
          el(
            "p",
            {
              style:
                "color:#003448;text-align:center;font-size:20px;margin-bottom:20px;font-weight:bold;line-height: 1.5;",
            },
            "Send a reset password link to user's email address"
          ),
          el(
            "p",
            { style: "color:#003448;font-size:13px;margin-bottom:-20px;" },
            "Email address"
          ),
        ]),
        "",
        {
          showClose: false,
          showCancelButton: true,
          confirmButtonText: "Send",
          cancelButtonText: "Cancel",
          showInput: true,
          inputPlaceholder: "Please enter email address",
          confirmButtonClass: "msg_button",
          cancelButtonClass: "msg_button",
          closeOnPressEscape: false,
          closeOnClickModal: false,
          inputPattern:
            /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
          inputErrorMessage: "Please provide a properly formatted email",
          inputValue: row.email ? row.email : "",
        }
      )
        .then(({ value }) => {
          let newValue = value;
          let oldValue = row.email;
          if (newValue == oldValue) {
            //without update email
            let params = { email: newValue, updateEmail: false };
            appUserResetPwd(row.id, params).then((res) => {
              if (res.data.status == "00") {
                this.$message.success(`Email is sent to ${newValue}`);
                this.getList();
              } else {
                this.$message.error(res.data.msg);
              }
            });
          } else {
            //update email
            const createEl = this.$createElement;
            this.$msgbox({
              message: createEl("div", { style: "padding:15px 0" }, [
                createEl(
                  "p",
                  {
                    style:
                      "color:#003448;text-align:center;font-size:20px;font-weight:bold;line-height: 1.5;",
                  },
                  "Do you need to updated the email address?"
                ),
              ]),
              showCancelButton: true,
              confirmButtonText: "Yes",
              cancelButtonText: "No",
              confirmButtonClass: "msg_button_half",
              cancelButtonClass: "msg_button_half",
              closeOnPressEscape: false,
              closeOnClickModal: false,
              callback: (action, instance) => {
                let params = {
                  email: newValue,
                  updateEmail: action == "confirm" ? true : false,
                };
                appUserResetPwd(row.id, params).then((res) => {
                  if (res.data.status == "00") {
                    this.$message.success(
                      action == "confirm"
                        ? `Email is sent to ${newValue} and the email address has been updated`
                        : `Email is sent to ${newValue}`
                    );
                    this.getList();
                  } else {
                    this.$message.error(res.data.msg);
                  }
                });
              },
            });
          }
        })
        .catch(() => {});
    },
    resetPwdNoPopup(row) {
      const el = this.$createElement;
      this.$prompt(
        el("div", { style: "padding:0 0 15px" }, [
          el(
            "p",
            {
              style:
                "color:#003448;text-align:center;font-size:20px;margin-bottom:20px;font-weight:bold;line-height: 1.5;",
            },
            `Create a temporary password. ${row.username}`
          ),
          el(
            "p",
            { style: "color:#003448;font-size:13px;margin-bottom:-20px;" },
            "Temporary Password"
          ),
        ]),
        "",
        {
          showClose: false,
          showCancelButton: true,
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showInput: true,
          inputPlaceholder: "Please enter temporary password",
          confirmButtonClass: "msg_button",
          cancelButtonClass: "msg_button",
          closeOnPressEscape: false,
          closeOnClickModal: false,
          inputValue: this.$commonjs.randomPassword(12),
          inputValidator: (v) => {
            let reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
            if (!v) {
              return "Password can not be empty";
            }
            if (v.indexOf(" ") != -1) {
              return "Password can not include space";
            }
            // if(v.length>20||v.length<8){
            //   return "Password's length must be 8-20"
            // }
            if (reg.test(v)) {
              return "Password can not contain Chinese";
            } else {
              return true;
            }
          },
        }
      )
        .then(({ value }) => {
          console.log(value);
          let params = { pwd: this.$encryptedRSAOAEP(value) };
          appUserResetPwd(row.id, params).then((res) => {
            if (res.data.status == "00") {
              this.$message.success(`The temporary password is ${value}. Email with temporary nassword has been sent to user.`);
              this.getList();
            } else {
              this.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {});
    },
    handleExport() {
      var list = this.exportList;
      var sort = "?sort=" + this.sort[0] + "&sort=" + this.sort[1];
      bizUserExport(list, sort).then((res) => {
        console.log(res);
      });
    },
    handleSchedule() {
      runFetchBizUserSchedule().then((res) => {
        console.log(res);
        if (res.data.status == "00") {
          this.$message.success("Run success!");
          this.demandDialog = false;
          this.getList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleClose(tag) {
      if (tag.type == "salesOffice") {
        this.formFilter.salesOffice = "All";
      } else if (tag.type == "region") {
        this.formFilter.region = "All";
      } else if (tag.type == "status") {
        this.formFilter.status = "All";
      } else if (tag.type == "sfUserType") {
        this.formFilter.sfUserType = "All";
      } else if (tag.type == "sfRecordType") {
        this.formFilter.sfRecordType = "All";
      } else if (tag.type == "account") {
        this.formFilter.account = "All";
      }
      this.tagList.splice(this.tagList.indexOf(tag), 1);
      this.getList();
    },
  },
  created: function () {
    this.showBtn("BUSINESS_PARTNER_WRITE");
    this.$emit("header", true);
    this.$commonjs.initRegionsMap();
    this.getList();
    this.getFilterConfig();
    this.getUserStatusConfig();
    this.getUserTypeConfig();
    this.getSfUserTypeConfig();
    this.getProducts();
    if (this.$store.state.userLevel >= 2) {
      this.formFilter.salesOffice = this.$store.state.salesOffices[0];
      this.changeSalesOffice(this.formFilter.salesOffice);
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == "editBizUser") {
      from.meta.keepAlive = true;
    } else {
      from.meta.keepAlive = false;
    }
    next();
  },
  activated() {
    if (this.$route.params.update) {
      this.getList();
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.search-toggle {
  display: inline-flex;
  align-items: center;
  column-gap: 4px;
  float: right;
  margin-right: 20px;
  line-height: 40px;
  font-size: 14px;
  font-weight: 600;
  color: #003448;
  cursor: pointer;
}
.search-toggle .el-icon-arrow-up {
  transition: transform 0.2s ease;
}
.search-toggle .el-icon-arrow-up.is-collapsed {
  transform: rotate(180deg);
}

.searchBox {
  padding: 20px;
  margin-bottom: 20px;
  background: #fff;
  border: 1px solid #e6ebee;
  border-radius: 8px;
}

.search-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  column-gap: 20px;
}

.search-grid /deep/ .el-form-item {
  margin-bottom: 16px;
}

.search-grid /deep/ .el-input__inner {
  width: 100%;
}

.search-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  row-gap: 12px;
  padding-top: 16px;
  margin-top: 16px;
  border-top: 1px solid #e6ebee;
}

.search-toolbar__actions .el-button {
  min-width: 96px;
}

.search-toolbar__extra {
  display: flex;
  align-items: center;
  column-gap: 20px;
}

/* Toolbar, table & pagination merged into one panel instead of three separate cards. */
.client-panel {
  background: #fff;
  border: 1px solid #e6ebee;
  border-radius: 8px;
  overflow: hidden;
}

.client-panel__toolbar {
  display: flex;
  justify-content: flex-end;
  padding: 14px 20px;
  border-bottom: 1px solid #e6ebee;
}

.client-panel__tags {
  display: flex;
  padding: 12px 20px 0;
}

.client-panel /deep/ .el-table {
  border: none;
  border-radius: 0;
}

.client-panel /deep/ .app-pagination {
  margin-top: 0;
  border: none;
  border-radius: 0;
  border-top: 1px solid #e6ebee;
}

.filterButton {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.sortbox {
  cursor: pointer;
}

.userstatus-OPENED {
  color: rgb(85, 130, 160);
}
.userstatus-ACTIVATED {
  color: rgb(0, 127, 80);
}
.userstatus-SUSPENDED {
  color: rgb(255, 0, 0);
}
.demandDialogTitle {
  font-size: 20px;
  text-align: center;
  padding-top: 10px;
  color: rgb(0, 52, 72);
  width: 88%;
  margin: 0 auto -20px;
  line-height: 26px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/bizUser/BizUser.vue